export default __webpack_public_path__ + "static/media/assembly_2.46386fbb.png";